import {Component, ElementRef, OnInit} from '@angular/core';
import {ThemeService} from '../../services/theme.service';

@Component({
  selector: 'app-theme-picker',
  templateUrl: './theme-picker.component.html',
  styleUrls: ['./theme-picker.component.scss']
})
export class ThemePickerComponent implements OnInit {
  public overlayIsOpen: boolean;
  public theme = this.themeService.theme;
  public themeName = this.themeService.theme;

  public themes = this.themeService.themes;

  constructor(protected themeService: ThemeService, private element: ElementRef) {
    // console.log(this.theme.getValue());
  }

  public clickedOutsideOverlay(event) {
    if (!this.element.nativeElement.contains(event.target)) {
      this.overlayIsOpen = false;
    }
  }

  public setTheme(theme) {
    this.themeService.setTheme(theme);
    this.overlayIsOpen = false;
  }

  ngOnInit() {
    return;
  }

}

